import React from 'react'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import ReactTooltip from 'react-tooltip';

export default class DetalhesPedido extends React.Component {
  exibirDadosCrianca (crianca) {
    if (crianca) {
      return <React.Fragment>
        <tr className="col-md-4">
          <td colSpan="3"><strong>Criança de colo: </strong>{capitalizarTodasPrimeirasLetras(crianca.nome)}</td>
          <td colSpan="2"><strong>Doc. embarque criança: </strong>{crianca.documentoCriacaComFoto}</td>
          <td><strong>Data nascimento criança: </strong>{crianca.dtNascimentoCrianca}</td>
        </tr>
      </React.Fragment>
    }
  }

  groupArrayOfObjects (list, key) {
    return list.reduce((rv, x) => {
      // eslint-disable-next-line no-param-reassign
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  exibirIconeObservacao(reserva) {
    if(!reserva.observacao){
      return ''
    }
    return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`situacao-reserva-${reserva.id}`}>
                  <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`situacao-reserva-${reserva.id}`}
                                type="dark" effect="solid">
                    <div className="row">{reserva.observacao}</div>
                  </ReactTooltip>
                </div>
              </span>
  }

  exibirPassageiros(reservas, delimitacao, pedido){
    return reservas.map(reserva => <React.Fragment key={reserva.id}>
      <tbody>
      <tr style={{backgroundColor: '#ffffff66'}}>
        <td colSpan='7' className='text-center'><strong>Número do bilhete:</strong> {reserva.id}</td>
      </tr>
      <tr>
        <td colSpan='3'><strong>Rota:</strong> {reserva.rota}</td>
        <td colSpan='2'><strong>Trecho:</strong> {`${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}`}</td>
        <td><strong>Ponto de embarque:</strong> {reserva.embarque}</td>
      </tr>
      <tr>
        <td><strong>Plataforma de embarque:</strong> {reserva.plataformaEmbarque}</td>
        <td colSpan='4'><strong>Delimitação:</strong> {delimitacao}</td>
        <td colSpan='2'><strong>Partida:</strong> {reserva.dataHoraPartida}</td>
      </tr>
      <tr>
        <td colSpan='3'><strong>Nome:</strong> {reserva.passageiroDto.nome}</td>
        <td><strong>DDI:</strong> {reserva.passageiroDto.siglaPais} {reserva.passageiroDto.ddi}</td>
        <td><strong>Telefone:</strong> {reserva.passageiroDto.telefone ? reserva.passageiroDto.telefone : ' - '}</td>
        <td><strong>Cpf:</strong> {reserva.passageiroDto.cpfPassageiro}</td>
      </tr>
      {pedido.emailComprador && <tr>
        <td colSpan={7}><strong>Email: </strong>{pedido.emailComprador}</td>
      </tr>}
      <tr>

      </tr>
      <tr>
        <td><strong>Poltrona:</strong> {reserva.numeroPoltrona}</td>
        <td><strong>Situação da reserva:</strong>
          {capitalizarTodasPrimeirasLetras(reserva.situacaoReserva.replace('_',' '))}
          {this.exibirIconeObservacao(reserva)}
        </td>
        <td><strong>Tarifa:</strong> {reserva.passageiroDto.tipoEmissao}</td>
        <td colSpan='3'><strong>Número Seguro:</strong> {reserva.numeroSeguro ? 'MBM-' + reserva.numeroSeguro.replace(/^(\d{4})(\d{6})(\d{1}).*/, '$1-$2-$3') : 'MBM-0000-000000-0'}</td>
      </tr>
      <tr>
        <td><strong>Valor bilhete:</strong> {Number(reserva.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
        <td><strong>Taxa embarque:</strong> {Number(reserva.taxaEmbarque).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
        <td colSpan='4'><strong>Cupom de Desconto ( - ) :</strong> {pedido.porcentagemCupom ? 
          Number(pedido.valorTotalDesconto).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })+ ' - ' + pedido.descricaoCupom + ' (' + pedido.porcentagemCupom + '%)' : ' - '}</td>
      </tr>
      {this.exibirDadosCrianca(reserva.passageiroDto.criancaDto)}
      </tbody>
    </React.Fragment>)

  }

  render () {
    if (!this.props.pedido.exibirDetalhe) {
      return ''
    }
    return (
      <div className="card-body cinza-zebrado table-responsive-sm">
        <table className="table table-sm table-bordered">

          {this.exibirPassageiros(this.props.pedido.reservas, this.props.pedido.delimitacao, this.props.pedido)}
        </table>
      </div>
    )
  }
}
